export default __webpack_public_path__ + "static/media/45.e5974ca7.png";